import { getRequest } from "./ApiService";

const KEY_MAP = {
  sales_clients: "salesClients",
  demand_growth_rate: "demandGrowthRate",
  accounts_receivable: "accountsReceivable",
  customer_preferences: "customerPreferences",
  features: "features",
  factories: "factories",
  ratings: "ratings",
  initial_demand: "initialDemand",
  prime_rates: "primeRates",
  machines: "machines",
  accounts_payable: "accountsPayable",
  total_demand: "totalDemand",
  marketing_clients: "marketingClients",
  constants: "constants",
  debt_clients: "debtClients",
  utilizations: "utilizations",
  comparable_companies: "comparableCompanies",
  equity_clients: "equityClients",
  customer_demand: "customerDemand",
  // Scalars returned by the business-case scope only. Camelcased for
  // consistency with the rest of KEY_MAP.
  bcase_price_floor: "bcasePriceFloor",
  bcase_price_ceiling: "bcasePriceCeiling",
  bcase_revenue_estimate: "bcaseRevenueEstimate",
};

// `scope` is an optional string ("business-case" is currently the only
// value the BE honors) that swaps the endpoint into a trimmed payload
// tuned for a single consumer. Without it, behavior is unchanged.
export function fetchAllStaticData(roundNumber, scope) {
  const base = `${process.env.REACT_APP_API_URL}static/all/`;
  const params = [];
  if (roundNumber != null) params.push(`round_number=${roundNumber}`);
  if (scope) params.push(`scope=${encodeURIComponent(scope)}`);
  const url = params.length > 0 ? `${base}?${params.join("&")}` : base;

  return getRequest(url).then(({ body }) => {
    const mapped = {};
    Object.keys(body).forEach(key => {
      const camelKey = KEY_MAP[key] || key;
      mapped[camelKey] = body[key];
    });
    return mapped;
  });
}



// WEBPACK FOOTER //
// ./src/api/StaticDataService.js